import React from "react";
import { useColors } from "../constants/Colors";

interface Tab {
  id: string;
  label: string;
  count?: number;
}

interface TabSwitcherProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

const TabSwitcher: React.FC<TabSwitcherProps> = ({
  tabs,
  activeTab,
  onTabChange,
}) => {
  const colors = useColors();

  return (
    <div
      className="flex gap-0.5 p-0.5 rounded-xl"
      style={{ backgroundColor: "rgba(2, 2, 16, 0.05)" }}
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className="relative px-3.5 py-1.5 text-sm font-gnarly-semibold transition-all duration-200 rounded-[10px]"
            style={{
              backgroundColor: isActive
                ? colors.containerNeutralSolidSurface
                : "transparent",
              color: isActive
                ? colors.textNeutralDefault
                : colors.textNeutralMuted,
              boxShadow: isActive
                ? "0 1px 3px rgba(2, 2, 16, 0.08), 0 0 0 1px rgba(2, 2, 16, 0.04)"
                : "none",
            }}
          >
            <span className="flex items-center gap-1.5">
              {tab.label}
              {tab.count !== undefined && (
                <span
                  className="text-[10px] min-w-[18px] h-[18px] flex items-center justify-center rounded-full font-gnarly-semibold leading-none"
                  style={{
                    backgroundColor: isActive
                      ? `${colors.accentColor}18`
                      : "rgba(2, 2, 16, 0.06)",
                    color: isActive
                      ? colors.accentColor
                      : colors.textNeutralMuted,
                  }}
                >
                  {tab.count}
                </span>
              )}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default TabSwitcher;
